import script from "./LiveItemBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveItemBar.vue?vue&type=script&setup=true&lang=ts"

import "./LiveItemBar.vue?vue&type=style&index=0&id=1c159cb6&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c159cb6"]])

export default __exports__